import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, input, inject } from '@angular/core';
import {RouterLink} from "@angular/router";
import {TooltipDirective} from '../tooltip/tooltip.directive';

interface IExternalHeaderItem {
  text: string;
  url: string;
}

@Component({
    selector: 'ui-external-header',
  imports: [
    RouterLink,
    TooltipDirective
  ],
    templateUrl: './external-header.component.html',
    styleUrl: './external-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalHeaderComponent implements OnInit, OnChanges {
  private cdr = inject(ChangeDetectorRef);

  readonly adminRouterLink = input('');
  readonly currentSiteName = input('');
  readonly iconClass = input('');
  isSiteExist = false;
  items: IExternalHeaderItem[] = [
    {
      text: 'Learning',
      url: 'https://learning.intersystems.com/'
    },
    {
      text: 'Documentation',
      url: 'https://docs.intersystems.com/'
    },
    {
      text: 'Community',
      url: 'https://community.intersystems.com/'
    },
    {
      text: 'Open Exchange',
      url: 'https://openexchange.intersystems.com/'
    },
    {
      text: 'Ideas Portal',
      url: 'https://ideas.intersystems.com/'
    },
    {
      text: 'Global Masters',
      url: 'https://globalmasters.intersystems.com/'
    },
    {
      text: 'Certification',
      url: 'https://www.intersystems.com/support-learning/learning-services/certification-program/'
    },

    {
      text: 'Partner Directory',
      url: 'https://partner.intersystems.com/'
    },
    {
      text: 'Startup Hub',
      url: 'https://startup.intersystems.com'
    },
    /*,
    {
      text: 'Health Innovation Hub',
      url: 'https://partner.intersystems.com/health-innovation-hub/'
    }*/
  ];

  ngOnInit() {
    this.checkSiteExists();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentSiteName'] && changes['currentSiteName'].currentValue !== changes['currentSiteName'].previousValue) {
      this.checkSiteExists();
      this.cdr.detectChanges();
    }
  }

  private checkSiteExists() {
    this.isSiteExist = this.items.some(el => el.text === this.currentSiteName());
  }
}
